import { emit, events } from 'elc-service-bus';

export interface IEngravingData {
    skuId: string;
    skuBaseId?: number;
    size: string;
    price: string;
    name: string;
}

export class ProductEngravingTriggeredUseCase {
    private engravingData: IEngravingData;

    constructor(engravingData: IEngravingData) {
        this.engravingData = engravingData;
    }

    public execute = () => {
        emit(events.SKU_ENGRAVING_TRIGGERED, this.engravingData);
    };
}
